module.exports = __webpack_public_path__ + "static/img/item2.974ce9ae.png";